import { lazy } from "react";

export const ProgramAndScheme = lazy(
  () => import("../../Features/ProgramAndSchemes")
);
